<template>
  <button v-on="$listeners"
          :disabled="disabled"
          class="eui-a-button"
          :type="type"
          :class="[variant ? `-${variant}`: '',
           color ? `-${color}`: '',
           size ? `-${size}`: '',
           {'-adaptSize': adaptSize},
           {'-iconOnly' : iconOnly},
           {'-selected' : selected},
           {'-disabled' : disabled}]">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      validator(value) {
        return ['raised', 'outlined', 'text', 'squared', 'outlined-squared'].indexOf(value) !== -1;
      },
    },
    adaptSize: {
      type: Boolean,
    },
    iconOnly: {
      type: Boolean,
    },
    color: {
      type: String,
      required: false,
      validator(value) {
        return ['primary', 'secondary', 'news', 'info', 'success', 'warning', 'error'].indexOf(value) !== -1;
      },
    },
    size: {
      type: String,
      required: false,
      validator(value) {
        return ['small', 'medium', 'large'].indexOf(value) !== -1;
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasOnlyIcon() {
      return (this.$slots.default.length === 1 &&
              this.$slots.default[0].tag === 'span' &&
              this.$slots.default[0].data.staticClass.includes('eui-icon-'));
    },
  },
};
</script>
